import { render, staticRenderFns } from "./ContestNolaNovelSelectItem.vue?vue&type=template&id=7f0288ff&scoped=true"
import script from "./ContestNolaNovelSelectItem.vue?vue&type=script&lang=ts"
export * from "./ContestNolaNovelSelectItem.vue?vue&type=script&lang=ts"
import style0 from "./ContestNolaNovelSelectItem.vue?vue&type=style&index=0&id=7f0288ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0288ff",
  null
  
)

export default component.exports